import { ITableColumn } from '@components/common/UTable/UTable';

import {
  DOSAGE_UNIT_LABELS,
  PACKAGE_MEASUREMENT_UNIT_LABELS,
} from '@/shared/pharmacy/enum';
import { enumToOptions } from '@/utils/utils';

export const columns = (
  onAmountSave: any,
  dataLength: number,
  displayEditButton: boolean,
) =>
  [
    {
      title: '№ партии',
      dataIndex: 'batchNumber',
      width: 175,
    },
    {
      title: 'Дата поступления/вскрытия',
      dataIndex: 'receiptDate',
      type: 'date',
      width: 150,
    },
    {
      title: 'Дата конца срока годности',
      dataIndex: 'expirationDate',
      className: 'expiration-text',
      type: 'date',
      width: 150,
    },
    {
      title: 'Срок годности после вскрытия (дней)',
      dataIndex: 'expirationPeriod',
      width: 150,
    },
    {
      title: 'Количество единиц тары в наличии',
      dataIndex: 'packagesAmount',
      className: 'amount-text',
      editable: {
        type: 'number',
        step: 1,
        min: 0,
        precision: 2,
        onSave: async (record, value, extra) => {
          await onAmountSave({ id: record?.id, packagesAmount: value, basis: extra });
        },
        displayEditButton: displayEditButton,
        extraField: {
          title: 'Основание',
          placeholder: 'Введите основание',
          maxLength: 250,
        },
        width: 250,
      },
      width: 150,
    },
    {
      title: 'Единица тары',
      dataIndex: 'packageUnit',
      type: 'select',
      payload: { options: enumToOptions(PACKAGE_MEASUREMENT_UNIT_LABELS) },
      width: 150,
    },
    {
      title: 'Единица содержимого',
      dataIndex: 'dosageUnit',
      type: 'select',
      payload: {
        options: enumToOptions(DOSAGE_UNIT_LABELS),
      },
      width: 150,
    },
    {
      title: 'Объем/доза препарата\nна единицу тары',
      dataIndex: 'packageVolume',
      width: 150,
    },
    {
      title: 'Требуемый минимальный остаток единиц тары',
      dataIndex: 'minAmount',
      onCell: (_record, index) => {
        if (index === 0) {
          return { rowSpan: dataLength };
        } else {
          return { rowSpan: 0 };
        }
      },
      width: 175,
    },
  ] as ITableColumn[];
